var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetInRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0026 3.99935V1.66602L4.08594 4.58268L7.0026 7.49935V5.16602C8.93344 5.16602 10.5026 6.73518 10.5026 8.66602C10.5026 10.5968 8.93344 12.166 7.0026 12.166C5.07177 12.166 3.5026 10.5968 3.5026 8.66602H2.33594C2.33594 11.2443 4.42427 13.3327 7.0026 13.3327C9.58094 13.3327 11.6693 11.2443 11.6693 8.66602C11.6693 6.08768 9.58094 3.99935 7.0026 3.99935Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetInRed);
export default __webpack_public_path__ + "static/media/Reset In Red.8889835fba6d53f01094ce4a3de8f58a.svg";
export { ForwardRef as ReactComponent };